module.exports = require 'views/core/CreateAccountModal/CreateAccountModal'
